import SquareFootIcon from '@mui/icons-material/SquareFoot';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import MapIconStyleWrapper from '../../../MapIconStyleWrapper';
import {
  selectIsOpenMeasurementPopup,
  setIsOpenMeasurementPopup,
} from '../../../mapSlice';

export const MapMeasureToolButton = () => {
  const isOpenMeasurementDialog = useAppSelector(selectIsOpenMeasurementPopup);
  const dispatch = useAppDispatch();

  const handleMeasureClick = () => {
    dispatch(setIsOpenMeasurementPopup(!isOpenMeasurementDialog));
  };

  return (
    <MapIconStyleWrapper
      icon={<SquareFootIcon />}
      showClickableCursor
      handleOnClick={handleMeasureClick}
    />
  );
};
